module.exports = __webpack_public_path__ + "img/18.3259c4e4.svg";